import { ContentLanguageTranslation } from '../../../types/InternalAnalystComment'
import { InternalTrackedGameReport } from '../../../types/InternalTrackedGameReport'

export enum InternalReportVisibility {
  Teaser = 'TEASER',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

/** A report as `GET i/reports` lists it. `analysts` are analyst ids; an unpublished report is stored with `publishedAt: 0`. */
export type InternalReport = Omit<InternalTrackedGameReport, 'visibility' | 'comment'> & {
  visibility: InternalReportVisibility
  /** `{}` when a report was created without a summary. */
  comment: ContentLanguageTranslation
}

/** Legacy's save body. `allowedUsers` is only sent for Private and Teaser reports; without it the backend stores `[]`. */
export type InternalReportMutation = {
  title: ContentLanguageTranslation
  coverUrls: string[]
  fileId: string
  analysts: string[]
  comment: ContentLanguageTranslation
  gameIds: string[]
  tags: string[]
  publishedAt: number
  published: boolean
  visibility: InternalReportVisibility
  allowedUsers?: string[]
  id?: string
}

/** The answer of `POST i/files/upload/` (`type=report`). */
export type InternalReportFile = {
  id: string
  name: string
  originalName: string
  contentType: string
  size: number
  type: string
}

export type InternalReportStatus = 'published' | 'scheduled' | 'draft'

/** A tag of `GET i/tags/list?type=report`; only the EN `name` is set. */
export type InternalReportTag = {
  id: string
  name: string
  type: 'report'
  active: boolean
  order: number
}

/** A related game as `POST games/list` answers it with legacy's list fields. */
export type InternalReportGame = {
  id: string
  appId: number
  name: string
  artist: string
  icon: string
  icons?: string[]
}
